import { get } from "./fetch";

export const getAllCategories = () => {
  return get(`/api/categories`, false);
}

export const getSubscribableCategories = () => {
  return get(`/api/seller/subscribable/categories`, true);
}

export const getAllSubscribableCategories = () => {
  return get(`/api/seller/all-subscribable/categories`, true);
}